import React from 'react';
import { NavLink,useHistory } from "react-router-dom";
import { auth } from './firebase/firebase';
import logo from "./img/LOGO.svg"
import "./css/Nav.css"

const Navbar = ({user})=> {
    const history=useHistory();

  //   document.getElementById("ticon").addEventListener("click", function (e) {
  //     var target = e.target;
  
  //     target.classList.toggle("&#xf0c9;");
  //     target.classList.toggle("&#xf00d;");
  // }, false);
  
    
    

    return (
        <>
   <nav className="navbar navbar-expand-lg navbar-dark">
  <NavLink className="navbar-brand" to="/"><img src={logo} alt="" className="img-fluid" /></NavLink>
  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
  <span style={{fontsize:"24px"}} className='fas' id="ticon">&#xf0c9;</span>
  </button>

  <div className="collapse navbar-collapse" id="navbarSupportedContent">
    <ul className="navbar-nav ml-auto">
      <li className="nav-item active">
        <NavLink className="nav-link" to="/"><i class='fas fa-clinic-medical'></i> Home </NavLink>
      </li>
      <li className="nav-item active">
        <NavLink className="nav-link" to="/Resource"><i class='fas fa-briefcase-medical'></i> Resource </NavLink>
      </li>
      <li className="nav-item active">
        <NavLink className="nav-link" to="/about"><i class='fas fa-file-medical'></i> About </NavLink>
      </li>
      {
        user?
        <>
        <li className="nav-item active">
        <NavLink className="nav-link" to="/dashboard"> <i class='fas fa-id-card-alt'></i> Dashboard</NavLink>
        </li>
        <button className="btn btn-success my-2 my-sm-0" onClick={
          ()=>{auth().signOut()
            history.push("/login")
          }
        }>LogOut</button>
        </>
        :
        <>
        <li className="nav-item active">
        <NavLink className="nav-link" to="/signup"> <i class='fas fa-user-nurse'></i> Signup</NavLink>
      </li>
      <li className="nav-item active">
        <NavLink className="nav-link" to="/login"> <i class='fas fa-user-md'></i> Login</NavLink>
      </li>
        </>
      }
    
     
    </ul>
    
  </div>
</nav> 
        </>
    );
};

export default Navbar;